<template>
 <div
   class="collection-categories-products"
   :class="{'--fixed': fixed}"
 >
   <div class="container">
     <div class="collection-categories-products__title h2">Товары этой коллекции</div>
     <div class="collection-categories-products__list">
       <template
         v-for="(section, index) in sections"
         :key="`section-${section.id}`"
       >
         <div
           class="category-button"
           :class="{'--active': Boolean(activeSection === section.slug)}"
           @click="() => clickSection(section, index)"
         >
           <span>
             {{ section.name }}
             <sub>{{(section.products || []).length}}</sub>
           </span>
           <nuxt-img
             :src="String(section.image_id)"
             width="32px"
             height="32px"
             fit="fill"
             :alt="`section-${section.id}-image-${section.image_id}`"
           />
         </div>
       </template>
     </div>
   </div>
 </div>
</template>

<script lang="ts" setup>
import { scrollToElement } from '~/utils/scrollToElement';

const props = defineProps({
  sections: {
    type: Array as any,
    default: () => []
  },
  activeSection: {
    type: String,
    default: ''
  },
  fixed: {
    type: Boolean,
    default: false
  }
});
const clickSection = (section: any, index: any) => {
  const offsetTopDesktop = Boolean(index === 0) ? 80 : 24;
  const offsetTopMobile = Boolean(index === 0) ? 60 : 40;
  const offseetTop = Boolean(window.innerWidth < 1023) ? offsetTopMobile : offsetTopDesktop;
  scrollToElement(`[data-section-slug="${ section.slug }"]`, {
    offseetTop: offseetTop
  });
}
</script>

<style lang="scss" scoped>
.collection-categories-products {
  max-width: 870px;
  &.--fixed {
    max-width: initial;
    position: fixed;
    top: 119px;
    background: white;
    z-index: 15;
    padding: 24px 0;
    width: 100%;

    .collection-categories-products__title {
      display: none;
    }
  }
}
.collection-categories-products.--fixed {
  left: 0;
  .container {
    padding: 0 80px;
  }
}

.collection-categories-products__title {
  margin-bottom: 24px;
}

.collection-categories-products__list {
  display: flex;
  flex-wrap: wrap;
  margin-top: -16px;
  margin-left: -16px;

  & > * {
    display: flex;
    cursor: pointer;
    margin-top: 16px;
    margin-left: 16px;
    padding: 10px 24px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #EBEBEB;
    color: #333;
    font-size: 16px;
    line-height: 100%;
    font-weight: 500;

    sub {
      margin-left: 5px;
      font-size: 12px;
      top: -5px;
      position: relative;
    }

    &:hover {
      background-color: #404040;
      border-color: #404040;
      color: white;
    }
    &.--active {
      background-color: #404040;
      border-color: #404040;
      color: white;
    }
  }
}

.category-button {
  img {
    display: none;
  }
}

@media (max-width: 1199px) {
  .collection-categories-products.--fixed {
    top: 116px;
    padding: 8px 0;
  }
  .collection-categories-products__list {
    margin-top: -4px;
    margin-left: -4px;
    & > * {
      margin-top: 4px;
      margin-left: 4px;
      padding: 8px 20px;
    }
  }
}
@media (max-width: 1023px) {
  .collection-categories-products {
    .collection-categories-products__list {
      flex-wrap: nowrap;
      overflow: auto;
      padding: 0 var(--container-padding);
      margin: -6px calc(var(--container-padding) * -1);
      & > * {
        border-radius: 10px;
        margin-left: 6px;
        margin-top: 6px;
      }
    }
  }
  .collection-categories-products.--fixed {
    top: 60px;
    padding: 33px 0 16px 0;
    box-sizing: border-box;
    //height: 52px;

    .container {
      padding: 0 var(--container-padding);
    }
  }

  .category-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: 48px;
    min-width: 48px;
    height: 48px;
    background-color: #F4F4F4;
    border-color: #F4F4F4;

    img {
      display: block;
      width: 32px;
    }
    span {
      display: none;
    }

    &.--active {
      &:hover {
        background-color: #404040;
        border-color: #404040;
      }
      & > img {
        filter: invert(1);
      }
    }

    &:hover {
      background-color: #F4F4F4;
      border-color: #F4F4F4;
    }
  }
}
</style>
